import {Decoder, object, field, number} from 'json-bouncer'

export interface ParcelPosition {
    id: number
    parcelId: number
    positionId: number
    amount: number
}

export function parcelPositionDecoder(): Decoder<ParcelPosition> {
    return object({
        id: field('id', number()),
        parcelId: field('parcelId', number()),
        positionId: field('positionId', number()),
        amount: field('amount', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ParcelPosition.ts